<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="wlsq-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="申请状态">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="search">
                <el-option label="待发货" :value="1" />
                <el-option label="已完成" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="search()">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                label="申请单号"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.manum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="brandname"
                label="品牌"
                show-overflow-tooltip
                align="center"
                width="90"
              >
              </el-table-column>
              <el-table-column
                label="部门"
                align="center"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.deptname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请人"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.username }}
                </template>
              </el-table-column>
              <el-table-column
                label="申请时间"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applytime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                min-width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                  <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请状态"
                width="120"
                fixed="right"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="danger">待结清</el-tag>
                  <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已完成</el-tag>
                  <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="warning">待发货</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="成本/元"
                fixed="right"
                align="center"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF;">{{ scope.row.addprice }}</span>
                </template>
              </el-table-column>
              <el-table-column
                width="180"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button v-if="scope.row.opertime===null||scope.row.opertime===''||scope.row.opertime===undefined" icon="el-icon-finished" size="mini" @click="edit(scope.row)">立即处理</el-button>
                  <el-button v-if="scope.row.opertime!==null&&scope.row.opertime!==''&&scope.row.opertime!==undefined" icon="el-icon-search" size="mini" @click="view(scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="editloading" :model="editForm" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ editForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">申请部门：</span>
          <span>{{ editForm.deptname }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ editForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="editForm.remark!==null&&editForm.remark!==''&&editForm.remark!==undefined">{{ editForm.remark }}</span>
          <span v-if="editForm.remark===null||editForm.remark===''||editForm.remark===undefined">N/A</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="editMaterialList"
          size="small"
          border
          row-key="material_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            property="unit"
            align="center"
            label="单位"
            width="80"
          >
          </el-table-column>
          <el-table-column
            property="cost"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            label="成本/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.counts>0&&scope.row.ischeck" style="font-weight: 500;color:#409EFF">{{ (scope.row.counts*scope.row.cost).toFixed(2) }}</span>
              <span v-if="scope.row.counts<=0||scope.row.ischeck!==true" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isview===false"
            label="库存"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.instock>=scope.row.counts">{{ scope.row.instock }}</span>
              <span v-if="scope.row.instock<scope.row.counts" style="font-weight: 500;color:#f56c6c">{{ scope.row.instock }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="isview===true">
          <span style="color:#99a9bf;">处理人：</span>
          <span>{{ editForm.opername }}</span>
          <span style="color:#99a9bf;margin-left:30px">处理时间：</span>
          <span>{{ editForm.opertime }}</span>
        </div>
        <div v-if="isview===true" style="margin:10px 0">
          <el-image
            v-for="iurl in imgSrcList"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="iurl"
            :preview-src-list="imgSrcList"
          >
          </el-image>
        </div>
        <el-form-item v-if="isview===false" label="审批图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-popconfirm v-if="isview===false" :key="btnKey" title="确认处理此物料申请单吗？" placement="top" @onConfirm="subEdit()">
            <el-button slot="reference" type="primary" icon="el-icon-check" :loading="editloading">立即处理</el-button>
          </el-popconfirm>
          <el-button icon="el-icon-printer" :loading="printLoading" style="margin-left:10px" @click="print(editForm.maid)">打印物料申领单</el-button>
          <el-button v-if="isview===false" @click="editVisible=false">取消</el-button>
          <el-button v-if="isview===true" @click="editVisible=false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getDeptTree,
  getMaterialClaimList,
  printMaterialsClaim,
  selectMaterialsClaim,
  treatMaterialClaim
} from '@/api/work'
import MultiImg from '@/components/upload/MultiImg'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Wlslcl',
  components: {
    MultiImg
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deptTree: [],
      searchForm: {
        search: '',
        type: null
      },
      editTitle: '',
      editVisible: false,
      editloading: false,
      editMaterialList: [],
      imgSrcList: [],
      isview: false,
      btnKey: '',
      editForm: {
        maid: '',
        manum: '',
        deptname: '',
        addprice: 0,
        remark: '',
        username: '',
        opertime: '',
        imgids: []
      },
      printLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.selectDeptTree()
  },
  methods: {
    print(id) {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        this.printLoading = true
        printMaterialsClaim({ maid: id }).then(response => {
          LODOP.PRINT_INIT('物料申领单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          this.printLoading = false
        }).catch(() => {
          this.printLoading = false
        })
      }
    },
    subEdit() {
      if (!this.editloading) {
        for (const m of this.editMaterialList) {
          if (m.instock < m.counts) {
            this.$message.error(m.material_name + ' 库存不足')
            return false
          }
        }
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          maid: this.editForm.maid,
          imgIds: this.editForm.imgids.join(',')
        }
        treatMaterialClaim(data).then(response => {
          this.editVisible = false
          this.editloading = false
          this.getData()
        })
      }
    },
    edit(row) {
      this.isview = false
      this.btnKey = new Date().getTime()
      this.editloading = true
      this.editTitle = '物料申领单'
      this.editForm.maid = row.maid
      this.editForm.manum = row.manum
      this.editForm.deptname = row.deptname
      this.editForm.addprice = row.addprice
      this.editForm.remark = row.remark
      this.editForm.username = row.username
      selectMaterialsClaim({ maid: row.maid }).then(response => {
        const materialsListVos = []
        for (const ma of response.data.materialsListVos) {
          if (ma.ischeck) {
            materialsListVos.push(ma)
          }
        }
        this.editMaterialList = materialsListVos
        this.editVisible = true
        this.editloading = false
      }).then(() => {
        this.editloading = false
      })
    },
    view(row) {
      this.isview = true
      this.btnKey = new Date().getTime()
      this.editloading = true
      this.imgSrcList = []
      this.editTitle = '物料申领单'
      this.editForm.maid = row.maid
      this.editForm.manum = row.manum
      this.editForm.deptname = row.deptname
      this.editForm.addprice = row.addprice
      this.editForm.remark = row.remark
      this.editForm.username = row.username
      this.editForm.opertime = row.opertime
      this.editForm.opername = row.opername
      selectMaterialsClaim({ maid: row.maid }).then(response => {
        const imgs = []
        for (const c of response.data.materialsClaim.imgList) {
          imgs.push(c.imgUrl)
        }
        this.imgSrcList = imgs
        const materialsListVos = []
        for (const ma of response.data.materialsListVos) {
          if (ma.ischeck) {
            materialsListVos.push(ma)
          }
        }
        this.editMaterialList = materialsListVos
        this.editVisible = true
        this.editloading = false
      }).then(() => {
        this.editloading = false
      })
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        status: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      getMaterialClaimList(data).then(response => {
        this.total = response.total
        this.tableData = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    selectDeptTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptTree(data).then(response => {
        this.deptTree = response.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
